export default __webpack_public_path__ + "static/media/frame214N2.1ac22460.svg";